import { prettyFloat } from 'webui/utils/number';
export function g2dk(g) {
    return Math.round(g * 10 + 2730);
}
export function dk2g(dk) {
    return (dk - 2730) / 10;
}
export function k2c(value) {
    return value / 10 - 273;
}
export function c2k(value) {
    return parseInt(((value + 273) * 10).toFixed(0), 10);
}
export function formatTemp(temp, precision = 1) {
    if (temp != null) {
        return `${prettyFloat(temp, precision)}°`;
    }
    return '';
}
